import useAuth from 'hooks/useAuth';

export default function useSaveUserConfig() {
  const { db, user } = useAuth();
  const userRef = db.collection('contacts').doc(user?.contactId);

  const saveUserConfig = (items: { [key: string]: any }) => {
    userRef.set({ userConfig: items }, { merge: true }).catch((error) => {
      console.error('Error updating user config: ', error);
    });
  };

  return saveUserConfig;
}
